import { render, staticRenderFns } from "./PodFilters.vue?vue&type=template&id=1214952c&scoped=true&"
import script from "./PodFilters.vue?vue&type=script&lang=ts&"
export * from "./PodFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1214952c",
  null
  
)

export default component.exports